import { QueryMetricsRequest } from "@/shared/domain/metrics";

/** A time bucket as carried on chart data (Unix-epoch nanoseconds). `bigint`
 *  so the clicked bucket's bounds reach the drill-down query at full ns
 *  precision instead of a rounded `number`. */
export interface BucketWindow {
  start_time: bigint;
  end_time: bigint;
}

/**
 * Page size for the drill-down dialog's paginated query.
 *
 * TODO(dave): Raise this page size limit & add a result count.
 * The backend can easily fetch these pages as an index-only scan, so
 * we can do all that easily enough.
 */
export const DRILLDOWN_PAGE_SIZE = 25;

/**
 * Build a raw-records query for the records that fall inside one aggregate
 * bucket. Used by the drill-down dialog. The window is bounded to the single
 * bucket and paginated at `maxResults`.
 */
export function bucketToQueryRequest(args: {
  name: string;
  bucket: BucketWindow;
  maxResults?: number;
  deviceIds?: string[];
  sessionIds?: string[];
}): QueryMetricsRequest {
  const {
    name,
    bucket,
    maxResults = DRILLDOWN_PAGE_SIZE,
    deviceIds,
    sessionIds,
  } = args;
  return {
    name,
    time_filter: "end_time",
    start_time_ns: bucket.start_time,
    end_time_ns: bucket.end_time,
    max_results: maxResults,
    include_device_ids: deviceIds,
    include_session_ids: sessionIds,
  };
}
